module.exports = __webpack_public_path__ + "media/images/3-highlighted-52814f15.png";